import translations from './translations.json';

const translationsByLang = translations.translations;
const defaultLang = 'en';

/**
 * Normalize to a BCP47-ish tag for HTML / accessibility.
 * Examples: pt_BR -> pt-BR, zh_CN -> zh-CN, ES -> es
 */
const normalizeLang = (lang) => {
    if (!lang) return defaultLang;

    const normalized = lang.replace("_", "-");
    const parts = normalized.split("-");

    if (parts.length === 1) {
        return parts[0].toLowerCase();
    }

    return `${parts[0].toLowerCase()}-${parts[1].toUpperCase()}`;
};

/**
 * Get text direction for a language
 * Returns 'rtl' for Arabic, 'ltr' for all other languages
 */
const getTextDirection = (lang) => {
    const isRTL = lang === 'ar';
    return isRTL ? 'rtl' : 'ltr';
};

const getCopy = (currentLang, key) => {
    const cleanKey = key.replace(/\.$/, '');
    return translationsByLang[currentLang][cleanKey] || translationsByLang[defaultLang][cleanKey];
}

export default {
    defaultLang,
    normalizeLang,
    getTextDirection,
    getCopy,
};



// WEBPACK FOOTER //
// ./src/i18n.js